import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuplicate = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				x: .888672,
				y: 4.44434,
				width: 10.6667,
				height: 10.6667,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .888672,
			y: 4.44434,
			width: 10.6667,
			height: 10.6667,
			rx: 1,
			stroke: "#002E5F",
			strokeWidth: 2.4,
			mask: "url(#path-1-inside-1)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-2",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				x: .888672,
				y: 4.44434,
				width: 10.6667,
				height: 10.6667,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .888672,
			y: 4.44434,
			width: 10.6667,
			height: 10.6667,
			rx: 1,
			stroke: "#002E5F",
			strokeWidth: 3,
			mask: "url(#path-2-inside-2)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.334 11.1113H14.2229V1.778H5.33398V2.66688",
			stroke: "#002E5F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDuplicate);
export default ForwardRef;
